import { Image as Img } from 'antd';

type Props = {
    src: string;
    width?: string | number;
    height?: string | number;
    style?: React.CSSProperties;
};

export const ImageSlide = ({ src, width = '100%', height = 300, style = {} }: Props) => {
    return (
        <div
            style={{
                width,
                height,
                backgroundColor: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Img
                src={src}
                width={width}
                height={height}
                alt={`uploaded-${src}`}
                style={{
                    objectFit: 'contain',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    ...style,
                }}
            />
        </div>
    );
};
